function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, i18n, InjectorHelper, ThunkHelper } from 'invision-core';
import LocaleKeys from '../../locales/keys';
import { NOTIFICATION_TIME_LENGTH } from '../../customercare.constants';
import { getDefaultPaymentMethodFromPaymentInstruments, isSupportedPaymentInstrumentType, isSupportedOTTPaymentInstrumentType } from '../helpers/ewallet.reducer.helper';
import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../../components/customer/ewallet/ewallet.constants';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
export var RETRIEVE_WALLET = {
  BEGIN: 'RETRIEVE_WALLET_BEGIN',
  SUCCESS: 'RETRIEVE_WALLET_SUCCESS',
  FAILURE: 'RETRIEVE_WALLET_FAILURE'
};
export var RETRIEVE_AVAILABLE_PAYMENT_INSTRUMENT_TYPES = {
  BEGIN: 'RETRIEVE_AVAILABLE_PAYMENT_INSTRUMENT_TYPES_BEGIN',
  SUCCESS: 'RETRIEVE_AVAILABLE_PAYMENT_INSTRUMENT_TYPES_SUCCESS',
  FAILURE: 'RETRIEVE_AVAILABLE_PAYMENT_INSTRUMENT_TYPES_FAILURE'
};
var RETRIEVE_WALLET_TYPES = [RETRIEVE_WALLET.BEGIN, RETRIEVE_WALLET.SUCCESS, RETRIEVE_WALLET.FAILURE];
var RETRIEVE_AVAILABLE_PAYMENT_INSTRUMENT_TYPES_TYPES = [RETRIEVE_AVAILABLE_PAYMENT_INSTRUMENT_TYPES.BEGIN, RETRIEVE_AVAILABLE_PAYMENT_INSTRUMENT_TYPES.SUCCESS, RETRIEVE_AVAILABLE_PAYMENT_INSTRUMENT_TYPES.FAILURE];
export var ADD_UNSAVED_PAYMENT_INSTRUMENT = 'ADD_UNSAVED_PAYMENT_INSTRUMENT';
export var REPLACE_WALLET_INSTRUMENTS = 'REPLACE_WALLET_INSTRUMENTS';
export var SELECT_PAYMENT_METHOD = 'SELECT_PAYMENT_METHOD';
export var RETRIEVE_WALLET_COMPLETED = 'RETRIEVE_WALLET_COMPLETED';
export var CLEAR_SELECTED_PAYMENT_METHOD = 'CLEAR_SELECTED_PAYMENT_METHOD';
export var CLEAR_IS_MAKING_PAYMENT = 'CLEAR_IS_MAKING_PAYMENT';
export var UPDATE_PAYMENT_ACCOUNTS_ON_SELECTED_PAYMENT_METHOD = 'UPDATE_PAYMENT_ACCOUNTS_ON_SELECTED_PAYMENT_METHOD';
export var CLEAR_EWALLET_RETRIEVAL_ERROR = 'CLEAR_EWALLET_RETRIEVAL_ERROR';
export var SET_EWALLET_RETRIEVAL_ERROR = 'SET_EWALLET_RETRIEVAL_ERROR';
export var SUPPLY_PAYMENT_INSTRUMENT = 'SUPPLY_PAYMENT_INSTRUMENT';
export var SET_RECORD_PAYMENT_INSTRUMENT = 'SET_RECORD_PAYMENT_INSTRUMENT';
export var SAVE_AUTO_PAY_FLAG_STATUS = 'SAVE_AUTO_PAY_FLAG_STATUS';
export var retrieveWalletPromise = function retrieveWalletPromise(dispatch, data, isProducts) {
  return ThunkHelper(dispatch, RETRIEVE_WALLET_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveWallet',
    data: data.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  }).then(function (response) {
    var ewalletPaymentInstruments = response.PaymentInstruments;
    var promises = ewalletPaymentInstruments.map(function (instrument) {
      return retrievePaymentInstrumentPromise(dispatch, {
        customerId: data.customerId,
        request: {
          Id: instrument.Id,
          RetrieveCurrencyEntitlementBalance: instrument.Type === convertStringToNumber(SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CURRENCY_ENTITLEMENT) || undefined
        }
      });
    });
    return Promise.all(promises).then(function (paymentInstruments) {
      var transformedInstruments = paymentInstruments.filter(function (instrument) {
        var isSupported = isProducts ? isSupportedOTTPaymentInstrumentType : isSupportedPaymentInstrumentType;
        return isSupported(instrument.PaymentInstrument.Type);
      }).map(function (instrument) {
        // Copy locked property from ewallet payment instrument to the current one.
        var ewalletPI = ewalletPaymentInstruments.find(function (paymentInstrument) {
          return paymentInstrument.Id === instrument.PaymentInstrument.Id;
        });
        instrument.PaymentInstrument.Locked = ewalletPI.Locked || false;
        return instrument.PaymentInstrument;
      });
      dispatch({
        type: REPLACE_WALLET_INSTRUMENTS,
        payload: transformedInstruments
      });
      dispatch({
        type: CLEAR_EWALLET_RETRIEVAL_ERROR
      });
      return transformedInstruments;
    }, function (errorPayload) {
      dispatch({
        type: SET_EWALLET_RETRIEVAL_ERROR,
        payload: errorPayload
      });
      return Promise.reject(errorPayload);
    });
  }).finally(function () {
    dispatch({
      type: RETRIEVE_WALLET_COMPLETED,
      payload: {}
    });
  });
};
export var retrieveAvailablePaymentInstrumentTypesPromise = function retrieveAvailablePaymentInstrumentTypesPromise(dispatch, data) {
  return ThunkHelper(dispatch, RETRIEVE_AVAILABLE_PAYMENT_INSTRUMENT_TYPES_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveAvailablePaymentInstrumentTypes',
    data: data
  });
};
export var retrieveWallet = function retrieveWallet(data, isProducts) {
  return function (dispatch) {
    return retrieveWalletPromise(dispatch, data, isProducts);
  };
};
export var retrieveAvailablePaymentInstrumentTypes = function retrieveAvailablePaymentInstrumentTypes(data) {
  return function (dispatch) {
    return retrieveAvailablePaymentInstrumentTypesPromise(dispatch, data);
  };
};
export var retrieveWalletAndSelectDefaultPaymentMethod = function retrieveWalletAndSelectDefaultPaymentMethod(data) {
  return function (dispatch) {
    return retrieveWalletPromise(dispatch, data).then(function (paymentInstruments) {
      dispatch({
        type: SELECT_PAYMENT_METHOD,
        payload: getDefaultPaymentMethodFromPaymentInstruments(paymentInstruments)
      });
    });
  };
};
export var RETRIEVE_PAYMENT_INSTRUMENT = {
  BEGIN: 'RETRIEVE_PAYMENT_INSTRUMENT_BEGIN',
  SUCCESS: 'RETRIEVE_PAYMENT_INSTRUMENT_SUCCESS',
  FAILURE: 'RETRIEVE_PAYMENT_INSTRUMENT_FAILURE'
};
var RETRIEVE_PAYMENT_INSTRUMENT_TYPES = [RETRIEVE_PAYMENT_INSTRUMENT.BEGIN, RETRIEVE_PAYMENT_INSTRUMENT.SUCCESS, RETRIEVE_PAYMENT_INSTRUMENT.FAILURE];
export var retrievePaymentInstrumentPromise = function retrievePaymentInstrumentPromise(dispatch, data) {
  return ThunkHelper(dispatch, RETRIEVE_PAYMENT_INSTRUMENT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrievePaymentInstrument',
    data: data.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  });
};
export var retrievePaymentInstrument = function retrievePaymentInstrument(data) {
  return function (dispatch) {
    return retrievePaymentInstrumentPromise(dispatch, data);
  };
};
export var REMOVE_PAYMENT_INSTRUMENT = {
  BEGIN: 'REMOVE_PAYMENT_BEGIN',
  SUCCESS: 'REMOVE_PAYMENT_SUCCESS',
  FAILURE: 'REMOVE_PAYMENT_FAILURE'
};
var REMOVE_PAYMENT_INSTRUMENT_EVENTS = [REMOVE_PAYMENT_INSTRUMENT.BEGIN, REMOVE_PAYMENT_INSTRUMENT.SUCCESS, REMOVE_PAYMENT_INSTRUMENT.FAILURE];
var removePaymentInstrumentPromise = function removePaymentInstrumentPromise(dispatch, customerId, paymentInstrumentId) {
  return ThunkHelper(dispatch, REMOVE_PAYMENT_INSTRUMENT_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RemovePaymentInstrument',
    data: {
      Id: paymentInstrumentId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var removePaymentInstrument = function removePaymentInstrument(customerId, paymentInstrumentId) {
  return function (dispatch) {
    return removePaymentInstrumentPromise(dispatch, customerId, paymentInstrumentId);
  };
};
export var ANONYMIZE_PAYMENT_INSTRUMENT = {
  BEGIN: 'ANONYMIZE_PAYMENT_BEGIN',
  SUCCESS: 'ANONYMIZE_PAYMENT_SUCCESS',
  FAILURE: 'ANONYMIZE_PAYMENT_FAILURE'
};
var ANONYMIZE_PAYMENT_INSTRUMENT_EVENTS = [ANONYMIZE_PAYMENT_INSTRUMENT.BEGIN, ANONYMIZE_PAYMENT_INSTRUMENT.SUCCESS, ANONYMIZE_PAYMENT_INSTRUMENT.FAILURE];
var anonymizePaymentInstrumentPromise = function anonymizePaymentInstrumentPromise(dispatch, customerId, paymentInstrumentId) {
  return ThunkHelper(dispatch, ANONYMIZE_PAYMENT_INSTRUMENT_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/AnonymizePaymentInstrument',
    data: {
      Id: paymentInstrumentId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var anonymizePaymentInstrument = function anonymizePaymentInstrument(customerId, paymentInstrumentId) {
  return function (dispatch) {
    return anonymizePaymentInstrumentPromise(dispatch, customerId, paymentInstrumentId);
  };
};
export var CHARGE_INSTRUMENT = {
  BEGIN: 'CHARGE_INSTRUMENT_BEGIN',
  SUCCESS: 'CHARGE_INSTRUMENT_SUCCESS',
  FAILURE: 'CHARGE_INSTRUMENT_FAILURE'
};
var CHARGE_INSTRUMENT_TYPES = [CHARGE_INSTRUMENT.BEGIN, CHARGE_INSTRUMENT.SUCCESS, CHARGE_INSTRUMENT.FAILURE];
var chargePaymentInstrumentPromise = function chargePaymentInstrumentPromise(dispatch, data, requestObject) {
  return ThunkHelper(dispatch, CHARGE_INSTRUMENT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SubmitOneTimePayment',
    data: data.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  }, requestObject);
};
export var chargePaymentInstrument = function chargePaymentInstrument(data) {
  return function (dispatch) {
    return chargePaymentInstrumentPromise(dispatch, data).then(function () {
      InjectorHelper.getUiNotificationService().success(i18n.translate(LocaleKeys.PAYMENT_SUCCESS), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    });
  };
};
export var CLEAR_EWALLET_ERROR = 'CLEAR_EWALLET_ERROR';
export var clearEWalletError = function clearEWalletError() {
  return {
    type: CLEAR_EWALLET_ERROR
  };
};
export var CREATE_PAYMENT_INSTRUMENT = {
  BEGIN: 'CREATE_PAYMENT_INSTRUMENT_BEGIN',
  SUCCESS: 'CREATE_PAYMENT_INSTRUMENT_SUCCESS',
  FAILURE: 'CREATE_PAYMENT_INSTRUMENT_FAILURE'
};
var CREATE_PAYMENT_INSTRUMENT_TYPES = [CREATE_PAYMENT_INSTRUMENT.BEGIN, CREATE_PAYMENT_INSTRUMENT.SUCCESS, CREATE_PAYMENT_INSTRUMENT.FAILURE];
var createPaymentInstrumentPromise = function createPaymentInstrumentPromise(dispatch, data) {
  return ThunkHelper(dispatch, CREATE_PAYMENT_INSTRUMENT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CreatePaymentInstrument',
    data: data.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  });
};
export var createPaymentInstrument = function createPaymentInstrument(data) {
  return function (dispatch) {
    return createPaymentInstrumentPromise(dispatch, data);
  };
};
export var REDEEM_GIFT_CARD = {
  BEGIN: 'REDEEM_GIFT_CARD_BEGIN',
  SUCCESS: 'REDEEM_GIFT_CARD_SUCCESS',
  FAILURE: 'REDEEM_GIFT_CARD_FAILURE'
};
var REDEEM_GIFT_CARD_TYPES = [REDEEM_GIFT_CARD.BEGIN, REDEEM_GIFT_CARD.SUCCESS, REDEEM_GIFT_CARD.FAILURE];
var redeemGiftCardPromise = function redeemGiftCardPromise(dispatch, PIN, customerId, accountNumber) {
  return ThunkHelper(dispatch, REDEEM_GIFT_CARD_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RedeemGiftCard',
    data: {
      Pin: PIN,
      AccountNumber: accountNumber
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var redeemGiftCard = function redeemGiftCard(PIN, customerId, accountNumber) {
  return function (dispatch) {
    return redeemGiftCardPromise(dispatch, PIN, customerId, accountNumber).then(function (redeemedGiftCard) {
      dispatch(retrieveWallet({
        request: {},
        customerId: customerId
      }));
      return redeemedGiftCard;
    });
  };
};
export var EDIT_PAYMENT_INSTRUMENT = {
  BEGIN: 'EDIT_PAYMENT_INSTRUMENT_BEGIN',
  SUCCESS: 'EDIT_PAYMENT_INSTRUMENT_SUCCESS',
  FAILURE: 'EDIT_PAYMENT_INSTRUMENT_FAILURE'
};
var EDIT_PAYMENT_INSTRUMENT_TYPES = [EDIT_PAYMENT_INSTRUMENT.BEGIN, EDIT_PAYMENT_INSTRUMENT.SUCCESS, EDIT_PAYMENT_INSTRUMENT.FAILURE];
var editPaymentInstrumentPromise = function editPaymentInstrumentPromise(dispatch, data) {
  return ThunkHelper(dispatch, EDIT_PAYMENT_INSTRUMENT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/UpdatePaymentInstrument',
    data: data.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  });
};
export var EDIT_PAYMENT_INSTRUMENT_AUTO_PAY = {
  BEGIN: 'EDIT_PAYMENT_INSTRUMENT_AUTO_PAY_BEGIN',
  SUCCESS: 'EDIT_PAYMENT_INSTRUMENT_AUTO_PAY_SUCCESS',
  FAILURE: 'EDIT_PAYMENT_INSTRUMENT_AUTO_PAY_FAILURE'
};
var EDIT_PAYMENT_INSTRUMENT_AUTO_PAY_TYPES = [EDIT_PAYMENT_INSTRUMENT_AUTO_PAY.BEGIN, EDIT_PAYMENT_INSTRUMENT_AUTO_PAY.SUCCESS, EDIT_PAYMENT_INSTRUMENT_AUTO_PAY.FAILURE];
var editPaymentInstrumentAutoPayPromise = function editPaymentInstrumentAutoPayPromise(dispatch, data) {
  return ThunkHelper(dispatch, EDIT_PAYMENT_INSTRUMENT_AUTO_PAY_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/UpdatePaymentInstrument',
    data: data.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  });
};
export var editPaymentInstrument = function editPaymentInstrument(data) {
  if (data.updateAutoPay) {
    return function (dispatch) {
      return editPaymentInstrumentAutoPayPromise(dispatch, data);
    };
  } else {
    return function (dispatch) {
      return editPaymentInstrumentPromise(dispatch, data);
    };
  }
};
export var setPaymentInstrumentDefault = function setPaymentInstrumentDefault(customerId, paymentMethod, applyToSubscriptions) {
  var data = {
    updateAutoPay: true,
    customerId: customerId,
    request: {}
  };
  if (applyToSubscriptions) {
    data.request.PaymentInstrument = paymentMethod;
    data.request.PaymentInstrument.Default = true;
    data.request.ApplyToSubscriptions = applyToSubscriptions;
  } else {
    data.request.DefaultPaymentInstrumentId = paymentMethod.Id;
  }

  //using DefaultPaymentInstrumentId will not return a fully populated payment Instrument, so wallet must be reloaded
  return function (dispatch) {
    return dispatch(editPaymentInstrument(data)).then(function (paymentInstrument) {
      dispatch(retrieveWallet({
        request: {},
        customerId: customerId
      }));
      return paymentInstrument;
    });
  };
};
export var activatePaymentInstrument = function activatePaymentInstrument(customerId, paymentMethod) {
  var data = {
    updateAutoPay: false,
    customerId: customerId,
    request: {
      IncludeRemoved: true,
      PaymentInstrument: paymentMethod
    }
  };
  return editPaymentInstrument(data);
};
export var selectPaymentMethod = function selectPaymentMethod(paymentMethod) {
  return {
    type: SELECT_PAYMENT_METHOD,
    payload: paymentMethod
  };
};
export var addUnsavedPaymentMethod = function addUnsavedPaymentMethod(paymentMethod) {
  return {
    type: ADD_UNSAVED_PAYMENT_INSTRUMENT,
    payload: paymentMethod
  };
};
export var supplyPaymentInstrument = function supplyPaymentInstrument(_supplyPaymentInstrument) {
  return {
    type: SUPPLY_PAYMENT_INSTRUMENT,
    payload: _supplyPaymentInstrument
  };
};
export var setRecordPaymentInstrument = function setRecordPaymentInstrument(recordPaymentInformation) {
  return {
    type: SET_RECORD_PAYMENT_INSTRUMENT,
    payload: recordPaymentInformation
  };
};
export var clearSelectedPaymentMethod = function clearSelectedPaymentMethod() {
  return {
    type: CLEAR_SELECTED_PAYMENT_METHOD
  };
};
export var resetIsMakingPayment = function resetIsMakingPayment() {
  return {
    type: CLEAR_IS_MAKING_PAYMENT
  };
};
export var updatePaymentAccountsOnSelectedPaymentMethod = function updatePaymentAccountsOnSelectedPaymentMethod(upatedPaymentAccounts) {
  return {
    type: UPDATE_PAYMENT_ACCOUNTS_ON_SELECTED_PAYMENT_METHOD,
    payload: upatedPaymentAccounts
  };
};
export var saveAutoPayFlagStatus = function saveAutoPayFlagStatus(autoPayPayload) {
  return {
    type: SAVE_AUTO_PAY_FLAG_STATUS,
    payload: autoPayPayload
  };
};
export var SET_INCLUDED_REMOVED_FILTER = 'SET_EWALLET_INCLUDED_REMOVED_FILTER';
export var setIncludeRemovedFilter = function setIncludeRemovedFilter(includedFilter) {
  return {
    type: SET_INCLUDED_REMOVED_FILTER,
    payload: includedFilter
  };
};
export var SET_SELECTED_ITEM_ID = 'SET_SELECTED_PAYMENT_ITEM_ID';
export var setSelectedItemId = function setSelectedItemId(includedId) {
  return {
    type: SET_SELECTED_ITEM_ID,
    payload: includedId
  };
};
export var SET_SELECTED_TYPE_ID = 'SET_SELECTED_PAYMENT_TYPE_ID';
export var setSelectedTypeId = function setSelectedTypeId(paymentTypeId) {
  return {
    type: SET_SELECTED_TYPE_ID,
    payload: paymentTypeId
  };
};
export var CLEAR_SELECTED_ITEM_ID = 'CLEAR_SELECTED_PAYMENT_ITEM_ID';
export var clearSelectedItemId = function clearSelectedItemId() {
  return {
    type: CLEAR_SELECTED_ITEM_ID
  };
};
export var CLEAR_SELECTED_TYPE_ID = 'CLEAR_SELECTED_PAYMENT_TYPE_ID';
export var clearSelectedTypeId = function clearSelectedTypeId() {
  return {
    type: CLEAR_SELECTED_TYPE_ID
  };
};
export var EMPTY_EWALLET_LIST = 'EMPTY_EWALLET_LIST';
export var emptyEWalletList = function emptyEWalletList() {
  return {
    type: EMPTY_EWALLET_LIST
  };
};
export var REMOVE_EWALLET_FILTER = 'REMOVE_EWALLET_FILTER';
export var removeEWalletFilter = function removeEWalletFilter() {
  return {
    type: REMOVE_EWALLET_FILTER
  };
};
export var UPDATE_OFFERING_INSTANCE_PAYMENT_INSTRUMENT = {
  BEGIN: 'UPDATE_OFFERING_INSTANCE_PAYMENT_INSTRUMENT_BEGIN',
  SUCCESS: 'UPDATE_OFFERING_INSTANCE_PAYMENT_INSTRUMENT_SUCCESS',
  FAILURE: 'UPDATE_OFFERING_INSTANCE_PAYMENT_INSTRUMENT_FAILURE'
};
var UPDATE_OFFERING_INSTANCE_PAYMENT_INSTRUMENT_TYPES = [UPDATE_OFFERING_INSTANCE_PAYMENT_INSTRUMENT.BEGIN, UPDATE_OFFERING_INSTANCE_PAYMENT_INSTRUMENT.SUCCESS, UPDATE_OFFERING_INSTANCE_PAYMENT_INSTRUMENT.FAILURE];
var updateOfferingInstancePaymentInstrumentPromise = function updateOfferingInstancePaymentInstrumentPromise(dispatch, customerId, offeringInstanceId, paymentInstrumentId) {
  return ThunkHelper(dispatch, UPDATE_OFFERING_INSTANCE_PAYMENT_INSTRUMENT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/UpdateOfferingInstancePaymentInstrument',
    data: {
      OfferingInstanceId: offeringInstanceId,
      PaymentInstrumentId: paymentInstrumentId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var updateOfferingInstancePaymentInstrument = function updateOfferingInstancePaymentInstrument(customerId, offeringInstanceId, paymentInstrumentId) {
  return function (dispatch) {
    return updateOfferingInstancePaymentInstrumentPromise(dispatch, customerId, offeringInstanceId, paymentInstrumentId);
  };
};
export var RENEW_OFF_CYCLE_CHARGES = {
  BEGIN: 'RENEW_OFF_CYCLE_CHARGES_BEGIN',
  SUCCESS: 'RENEW_OFF_CYCLE_CHARGES_SUCCESS',
  FAILURE: 'RENEW_OFF_CYCLE_CHARGES_FAILURE'
};
var RENEW_OFF_CYCLE_CHARGES_TYPES = [RENEW_OFF_CYCLE_CHARGES.BEGIN, RENEW_OFF_CYCLE_CHARGES.SUCCESS, RENEW_OFF_CYCLE_CHARGES.FAILURE];
var renewOffCycleChargesPromise = function renewOffCycleChargesPromise(dispatch, customerId, subscriberProductIds, orderId) {
  return ThunkHelper(dispatch, RENEW_OFF_CYCLE_CHARGES_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetryOffCyclePayment',
    data: {
      OrderId: orderId,
      SubscriberProductIds: subscriberProductIds
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var renewOffCycleCharges = function renewOffCycleCharges(customerId, subscriberProductIds, orderId) {
  return function (dispatch) {
    return renewOffCycleChargesPromise(dispatch, customerId, subscriberProductIds, orderId);
  };
};